export default __webpack_public_path__ + "static/media/cloud2.4c6aee84.png";